export default __webpack_public_path__ + "static/media/history.3f52c76c.svg";